export default __webpack_public_path__ + "static/10-ffff02791333b65256fe0cb96f2b8152.png";